import { Instagram as Instagram_filmzi } from './Instagram.filmzi';
import { Instagram as Instagram_kojaro } from './Instagram.kojaro';
import { Instagram as Instagram_phosphor } from './Instagram.phosphor';
import { Instagram as Instagram_zoomg } from './Instagram.zoomg';
import { Instagram as Instagram_zoomit } from './Instagram.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'filmzi':
      return Instagram_filmzi;

    case 'kojaro':
      return Instagram_kojaro;

    case 'zoomg':
      return Instagram_zoomg;

    case 'phosphor':
      return Instagram_phosphor;

    default:
      return Instagram_zoomit;
  }
};

export const Instagram = IconRenderer();
